"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Row = _interopRequireDefault(require("../baseComponents/Row"));

var _Col = _interopRequireDefault(require("../baseComponents/Col"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ProgressBar = function ProgressBar(props) {
  var progress = props.progress;
  var isUnlimited = props.maxProgress === "unlimited";
  var progressText = "";
  var progressInPercent = 0;

  if (!isUnlimited) {
    progressInPercent = progress * 100 / props.maxProgress;

    if (progress < 0) {
      progress = 0;
    }
  } else {
    progressInPercent = 100;
  }

  var componentClass = (0, _classnames["default"])("progressBar-component", props.className, props.size, {
    "unlimited": isUnlimited,
    "warning": props.showWarning && !isUnlimited && progressInPercent > props.warningLimit,
    "busted": props.showBusted && !isUnlimited && progress > props.maxProgress
  });
  var progressStyle = {
    "width": progressInPercent + "%"
  };

  if (props.showTextProgress) {
    progressText = /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "progressText"
    }, progress), " / ", /*#__PURE__*/_react["default"].createElement("span", null, props.maxProgress));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: componentClass,
    style: props.style
  }, props.sideLabel && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h6", null, props.sideLabel)), /*#__PURE__*/_react["default"].createElement("div", null, (props.label || props.showTextProgress) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "topTextContainer"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h6", null, props.label)), props.showTextProgress && /*#__PURE__*/_react["default"].createElement("div", null, progressText)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "progressBarContainer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "progressBar"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "progress",
    style: progressStyle
  })), isUnlimited && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "micro-glyph-infinity"
  }))));
};

ProgressBar.propTypes = {
  sideLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  progress: _propTypes["default"].number,
  maxProgress: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].object, _propTypes["default"].oneOf(['unlimited'])]),
  showTextProgress: _propTypes["default"].bool,
  showWarning: _propTypes["default"].bool,
  warningLimit: _propTypes["default"].number,
  showBusted: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(["small", "medium", "big"]),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
ProgressBar.defaultProps = {
  sideLabel: null,
  label: null,
  progress: 100,
  maxProgress: 100,
  showTextProgress: false,
  showWarning: false,
  warningLimit: 80,
  showBusted: false,
  size: "medium",
  className: "",
  style: {}
};
var _default = ProgressBar;
exports["default"] = _default;